import React, { FC } from "react";
import { TaxonomyType } from "data/types";
import CardCategory1 from "components/CardCategory1/CardCategory1";
import NcModal from "components/NcModal/NcModal";
import Button from "components/Button/Button";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { useCategoriesQuery } from "framework/rest/category/categories.query";

export interface ModalCategoriesProps {
  categories: TaxonomyType[];
}

const ModalCategories: FC<ModalCategoriesProps> = ({ categories }) => {
  const { data, isLoading } = useCategoriesQuery({
    limit: 5,
  });

  if (isLoading) return <div>Loading...</div>;

  const renderModalContent = () => {
    return (
      <div className="grid gap-6 sm:grid-cols-2 sm:py-2 md:gap-8 md:grid-cols-3 lg:grid-cols-4 xl:md:grid-cols-5">
            {data?.categories.data.map((category) => (
            <CardCategory1
              key={category.id}
              image={category.image}
              name={category.name}
              data={category}
            />
          ))}
      </div>
    );
  };

  return (
    <div className="nc-ModalCategories">
      <NcModal
        renderTrigger={(openModal) => (
          <Button
            pattern="third"
            fontSize="text-sm font-medium"
            onClick={openModal}
          >
            <div>
              <span className="hidden sm:inline"> Kategoriler </span>
            </div>
            <ChevronDownIcon
              className="w-4 h-4 ml-2 -mr-1"
              aria-hidden="true"
            />
          </Button>
        )}
        modalTitle="Tüm Kategoriler"
        renderContent={renderModalContent}
      />
    </div>
  );
};

export default ModalCategories;
